// const { default: bottomNavbar } = require("../../components/bottomNavbar.vue");

module.exports = {
  App: {
    documentTitle:'5g多功能智慧路灯_智慧灯杆系统解决方案厂家-深圳市云之声科技有限公司',
    name: '名称',
    header:{
      text1:'全球数智照明全栈解决方案服务商',
      text2:'搜索',
      text3:'取消',
      text4:'首页',
      text5:'解决方案',
      text6:'道路照明',
      text7:'智慧灯杆',
      text8:'体育照明',
      text9:'工业照明',
      text10:'隧道照明',
      text11:'智慧园区',
      text12:'城市生命线',
      text13:'数智照明',
      text14:'数智驱动控制器',
      text15:'照明控制器',
      text16:'回路控制',
      text17:'网关与基站',
      text18:'传感器',
      text19:'输入面板',
      text20:'智慧合杆',
      text21:'杆站选型',
      text22:'边缘计算网关',
      text23:'核心组件',
      text24:'AI与数据',
      text25:'软件系统',
      text26:'We照明云',
      text27:'数字孪生',
      text28:'APP客户端',
      text29:'服务',
      text30:'案例',
      text31:'售前质询',
      text32:'售后支持',
      text33:'关于',
      text34:'云之声科技',
    },
    home:{
      text1:'数智驱动控制器',
      text2:'AIOT赋能数字照明',
      text3:'PFC+LLC设计、效率高耐用无频闪、高低压输出',
      text4:'立即查看',
      text5:'智启未来 万物互联',
      text6:'AIOT路灯（盏）',
      text7:'8年',
      text8:'专注数字照明',
      text9:'120+项',
      text10:'专利等知识产权',
      text11:'30+国家',
      text12:'业务覆盖全球',
      text13:'150+城市',
      text14:'落地项目案例',
      text15:'智慧灯杆',
      text16:'了解更多',
      text17:'超级合作伙伴',
      text18:'了解更多',
      text19:'你想了解哪类产品',
      text20:'数智LED驱动控制器',
      text21:'照明控制器',
      text22:'智慧合杆',
      text23:'通信与传感器',
      text24:'软件与系统',
      text25:'道路照明',
      text26:'工矿照明',
      text27:'景观照明',
      text28:'植物照明',
      text29:'特种照明',
      text30:'查看更多',
      text31:'新闻中心',
      text32:'第二十九届广州国际照明展览会',
      text33:'中国，广州',
      text34:'2024年6月09日 - 12日',
      text35:'云之声科技以“全球数智照明全栈方案”为核心,携数智驱动控制器（一体化数智电源）、城市生命线专区、联动传感器专区及控制器专区等15大板块产品。',
      text36:'2024湖南照明科技论坛',
      text37:'中国，湖南',
      text38:'2024年5月24日',
      text39:'本次会议将以“绿色低碳、融合创新”为主题，推动照明科技领域的绿色发展和融合创新，云之声科技受邀协办并作数字化道路照明专题汇报，为湖南照明科技的未来发展注入新的活力和动力。',
      text40:'道路·管廊·低空｜未来道路数字孪 生全息感知中台',
      text41:'2024年4月24日',
      text42:'亚欧国际交通博览会｜云之声科技',

      companyProfile:'深圳市云之声科技有限公司成立于 2016 年，是一家专业从事数字化产品研发、生产、销售与服务于一体的国家高新技术企业和专精特新企业。经过数年的发展，公司产品形成了中台 + 硬件 + AloT + 场景 + 计算的全栈解决方案。专注于物联网技术、数字孪生技术、电源与控制技术、传感与传输技术赋能传统行业转型，提供可靠的、前沿的核心组件与控制中台。在道路照明、工业照明、多功能合杆、隧道照明、体育照明、智慧园区、城市生命线等场景有非常丰富的项目经验以及成熟的配套解决方案与产品。有一个研发中心和两个工厂，总人数约 100 人，其中研发人员 40 余人。',
    },
    smartLighting:{
      text1:'数智照明',
      text2:'数智驱动控制器',
      text3:'照明控制器',
      text4:'回路控制',
      text5:'网关与基站',
      text6:'传感器',
      text7:'输入面板',
      text8:'联系我们',
      text9:'查看详情',
      text10:'2.4G版本 WE-XXX-48B',
      text11:'超高功率密度，效率高达92%',
      text12:'内置有源PFC,实现高PF/低THD',
      text13:'隔离调光：4G和BLUE',
      text14:'使用场所:道路照明/工业照明/楼宇场馆亮化',
      text15:'CAT1低压版本 WE-XXX-48G',
      text16:'CAT1高压版本 WE-XXX-48G-H',
      text17:'CAT1版本双路 WE-XXX-48G-D',
      text18:'Thread版本(IPV6) WE-XXX-48T',
      text19:'WI-SUN(IPV6)版本 WE-XXX-48W',
      text20:'大功率恒流 WE-XXX-48G-C',
      text21:'大功率恒压 WE-XXX-48G-V',
      text22:'工业照明UFO电源 WE-XXX-48G-UFO',
    },
    bottomNavbar:{
      text1:'解决方案',
      text2:'道路照明',
      text3:'智慧灯杆',
      text4:'体育照明',
      text5:'工业照明',
      text6:'隧道照明',
      text7:'智慧园区',
      text8:'城市生命线',

      text9:'数智照明',
      text10:'数智驱动控制器',
      text11:'照明控制器',
      text12:'回路控制',
      text13:'网关与基站',
      text14:'传感器',
      text15:'输入面板',

      text16:'智慧合杆',
      text17:'杆站选型',
      text18:'边缘计算网关',
      text19:'核心组件',
      text20:'AI与数据',

      text21:'软件系统',
      text22:'Wemind',
      text23:'We照明云',
      text24:'数字孪生',
      text25:'APP客户端',
      
      text26:'服务',
      text27:'案例',
      text28:'售前咨询',
      text29:'售后支持',

      text30:'了解云之声',
      text31:'关于我们',
      text32:'云之声新闻',

      text33:'联系我们',
      text34:'业务咨询（张工）',
      text35:'市场合作',
      text36:'研发地址',
      text37:'工厂地址',
      text38:'深圳市光明区',
      text39:'深圳市龙岗区',

      text40:'关注“云之声科技”',

      text41:'深圳市南山区留仙大道尚美国际大厦 2309-2310室',

    },
    smartLightingInfo: {
      text1:'首页>数智照明>数智驱动控制器>2.4G版本WE-XXX-48B',
      text2:'2.4G数智驱动控制器',
      text3:'2.4G版本WE-XXX-48B系列数智驱动控制器，是一款支持云端无线控制调光、开关的LED 交流变直流控制器，产品支持 4G cat.1、2.4G mesh 组网、NB-IoT等通讯方式。结合本公司自主产权的智慧城市云平台，实现照明亮化的智能控制。',
      text4:'数智驱动控制器具有电网参数采集、调光功能、高温保护功能，支持灯具的单点控制、批量控制、策略控制，经纬度控制等功能，具有完善的故障报警系统，能大大减少项目运维成本，实现了智能、节能、绿色环保。',
      text5:'在路灯、植物照明、景观照明、工业照明等场景具有广泛的应用。具有最高可达92%之高转换效率，全金属外壳以及 IP67高防护等级之设计，可于自然风冷散热下工作于-40℃~+90℃之机壳温度范围。使得数智驱动控制器对于户内或户外的应用均适用。',
      text6:'所属分类：',
      text7:'关键词：',
      text8:'规格参数和选型列表',
      text9:'接线方式',
      text10:'资料下载',
      text11:'产品定位：道路照明、工业照明、楼宇场馆亮化',
      text12:'通信方式：2.4G Mesh',
      text13:'产品特性：内置有源PFC,实现高PF/低THD',
      text14:'隔离调光：4G和BLUE',
      text15:'雷击保护：L-N(差模)：6KV L/N-PE(共模)：10KV',
      text16:'过温保护：功率降额，温度下降后恢复满载',
      text17:'防护等级：IP67',
      text18:'安全规范：符合GB19510.1,GB19510.14',
      text19:'电磁辐射：符合GB17743 和GB17625.1',
      text20:'产品认证：3C/CE/FCC※/RoHS',
      text21:'售后保障：三年质保',
      text22:'产品型号',
      text23:'输出电压',
      text24:'额定功率',
      text25:'输入电流',
      text26:'工作壳温',
      text27:'频率范围',
      text28:'输入漏电流',
      text29:'储存温度和湿度',
      text30:'2.4G版本',
      text31:'云之声控制器 道路照明',
    }
  }
}